/**
 * Synthetic LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UpdatePairSettingRequest {
  /**
   * Synthetic base pair ID.
   */
  basePairId: number;
  /**
   * Second leg base pair ID.
   */
  secondLegBasePairId: number;
}
